import { CustomSwitch } from 'ui';

interface ArchiveSwitchProps {
  active: boolean;
  onChange: (value: boolean) => void;
}

const ArchiveSwitch = ({ active, onChange }: ArchiveSwitchProps) => {
  return (
    <CustomSwitch
      value={active}
      label="Show archived"
      onChange={onChange}
      className="text-sm"
      classNameContainer="items-center shrink-0"
      style={{ backgroundColor: active ? '#171717' : undefined }}
    />
  );
};

export default ArchiveSwitch;
